import {ReactNode} from "react";
import Form from "react-bootstrap/Form";

interface SettingToggleProps {
    id: string;
    label: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
    action?: ReactNode;
    children?: ReactNode;
}

export function SettingToggle({id, label, checked, disabled, onChange, action, children}: SettingToggleProps) {
    return (
        <div className="setting-toggle">
            <div className="setting-toggle__head">
                <Form.Check
                    type="switch"
                    id={id}
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                    className="custom-switch setting-toggle__switch"
                />
                <div className="setting-toggle__text">
                    <label htmlFor={id} className="setting-toggle__label">{label}</label>
                </div>
                {action}
            </div>
            {children && <div className="setting-toggle__body">{children}</div>}
        </div>
    );
}
